import React from "react";
export function roleName(name?: string | null) {
  return name ? name.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ") : "Unassigned";
}
export function RoleBadge({ name }: { name?: string | null }) {
  const tone = name === "SUPER_ADMIN" ? "orange" : name === "FINANCE_ADMIN" ? "purple" : name === "SUPPORT_ADMIN" ? "green" : "blue";
  return <span className={`access-role-badge access-role-badge--${tone}`} title={name || undefined}>{roleName(name)}</span>;
}
export default function MemberIdentity({ name, own = false }: { name: string; own?: boolean }) {
  const initials = name.trim().split(/\s+/).slice(0, 2).map(word => word[0]).join("").toUpperCase();
  return <div className="access-member"><span className="access-member__avatar" aria-hidden="true">{initials || "?"}</span><span className="access-member__name">{name}{own && <span className="access-you">You</span>}</span></div>;
}
